// initialize cart carousel after cart refresh
// function initializeCartCarousel() {
//   $('.home-prd-car-drawer').owlCarousel('destroy');
//   $('.home-prd-car-drawer').owlCarousel({
//     loop: false,
//     margin: 10,
//     nav: true,
//     dots: false,
//     autoWidth: true,
//     stagePadding: 20,
//     center: false,
//     navText: [
//       '<svg xmlns="http://www.w3.org/2000/svg" width="50" height="30" viewBox="0 0 50 30" fill="none"> <path d="M43.75 15L6.25 15" stroke="#413F47" stroke-linecap="round" stroke-linejoin="round"/> <path d="M15 6.25L6.25 15L15 23.75" stroke="#413F47" stroke-linecap="round" stroke-linejoin="round"/> </svg>',
//       '<svg xmlns="http://www.w3.org/2000/svg" width="50" height="30" viewBox="0 0 50 30" fill="none"> <path d="M6.25 15L43.75 15" stroke="#413F47" stroke-linecap="round" stroke-linejoin="round"/> <path d="M35 6.25L43.75 15L35 23.75" stroke="#413F47" stroke-linecap="round" stroke-linejoin="round"/> </svg>',
//     ],
//     responsive: {
//       0: {
//         items: 2,
//         nav: false,
//         dots: true,
//         autoWidth: true
//       },
//       768: {
//         items: 4,
//         autoWidth: true,
//         margin: 4
//       },
//       1200: {
//         items: 5,
//         margin: 4
//       },
//     },
//   });
//   console.log('initialised Carousel from main func');
// }

document.addEventListener('click', function (event) {
  if (event.target.classList.contains('quantity__button') && event.target.closest('.cart-quantity')) {
    const button = event.target;

    setTimeout(() => {
      // Retain Coupon Code
      const couponCode= $('#discount-code-input').val();
      if (couponCode) {
        // console.log('ccode: '+couponCode);
        applyDiscount(document.querySelector('#discount-code-input').value);
        // $('#apply-discount-btn').click();
      }
    }, 2000);
  }
});

cartScrollPosition=0;
document.addEventListener('click', function (event) {
  if (event.target.closest('.cart-drawer')) {
    cartScrollPosition = document.querySelector('.drawer__inner').scrollTop;
    console.log(cartScrollPosition);
  }
});

// listens for cart quantity 
// const cartDrawerItems = $('.header__icon--cart')[0]; // Get the first element from the jQuery object
// const observer1 = new MutationObserver(async function (mutationsList) {
//   for (let mutation of mutationsList) {
//     if(mutation.target.id){
//          if (mutation.type === 'childList' || mutation.type === 'subtree') {
//         // initializeCartCarousel();
//         // uncomment below functions for freebie sale
//         await handleFreeGift();
//         handleCoupons();
//         updatePrices();
//         document.querySelector('.drawer__inner').scrollTop = cartScrollPosition;
//         if($('cart-drawer-items .cart-items tbody').children('tr').hasClass('freebie-product')){
//           setTimeout(()=>{
//             let timeInterval = setInterval(()=>{
//               if($('cart-drawer-items .cart-items tbody').children('tr').eq(0).hasClass('freebie-product')){
//                 clearInterval(timeInterval);
//               }
//             },300);
//           },1500)
//         }
//         if(window.location.pathname == '/cart'){
//           // window.location.reload();
//         }
//         break;
//       }
//     }
//   }
// });
// const config = { childList: true, subtree: true };
// observer1.observe(cartDrawerItems, config);

// if (window.location.pathname == '/cart') {
//   function sortCartPage() {
//     var cartItems = $('cart-items .cart-items tbody').children('tr');

//     cartItems.sort(function (a, b) {
//       var aHasFreebie = $(a).hasClass('freebie-product');
//       var bHasFreebie = $(b).hasClass('freebie-product');
//       if (aHasFreebie && !bHasFreebie) {
//         return -1; // 'a' comes before 'b'
//       } else if (!aHasFreebie && bHasFreebie) {
//         return 1; // 'b' comes before 'a'
//       } else {
//         return 0;
//       }
//     });
//     $('cart-items .cart-items tbody').html(cartItems);
//   }
//   sortCartPage();
// }

// for cart prices update after adding new products
updatePrices();
function updatePrices() {
  let regularTotal = 0;
  let discountPrice = 0;
  let shippingPrice = 0;
  let sellingPrice = 0;
  let totalPrice = 0;
  const $shippingPriceElement = $('.cart-shipping-price');
  const shippingThreshold = $shippingPriceElement.data('shipping-threshold');
  const shippingCharges = $shippingPriceElement.data('shipping-charges');

  $('.cart-items-regular-price').each((index, item)=>{
    regularTotal += parseInt($('.cart-items-quantity').eq(index).val()) * parseInt($(item).val().replace(',', ''));
  })
  if ($('.cart-items-total').val() != undefined) {
    discountPrice = parseInt(regularTotal) - parseInt($('.cart-items-total').val().replace(',', ''));
  }

  sellingPrice = regularTotal - discountPrice;
  discountAmount = regularTotal - sellingPrice;
  if (sellingPrice > shippingThreshold) {
    shippingPrice = '<s>₹49</s> Free';
    totalPrice = sellingPrice;
  } else {
    shippingPrice = '₹' + shippingCharges;
    totalPrice = sellingPrice + shippingCharges;
  }
  let TOTALOF1399 = 0;
  $('.cart-items-1399-price').each((index, item)=>{
    TOTALOF1399 += parseInt($('.cart-items-1399-quantity').eq(index).val()) * parseInt($(item).val().replace(',',''));
  })

  let activeBYOB = 0;
  let freebiesavings = 0;
  async function cartItemsData() {
    const res = await fetch('/cart.js');
    const response = await res.json();
    return response.items; // Return just the array of cart items
  }
  async function cartSavingsUpdate() {
    const cart = await cartItemsData();
    const productIds = cart.map(item => item.product_id.toString());

    const hasScalp = productIds.includes('7921931976874');
    const hasArganMask = productIds.includes('8289829421226');
    const hasArganSerum = productIds.includes('8289818902698');
    const hasScrunchie = productIds.includes('7965535436970');
    const hasTotebag = productIds.includes('7353170755754');

    if (hasScalp) freebiesavings += 600;
    if (hasArganMask) freebiesavings += 125;
    if (hasArganSerum) freebiesavings += 120;
    if (hasScrunchie) freebiesavings += 200;
    if (hasTotebag) freebiesavings += 500;

    if (freebiesavings) {
      discountPrice = discountPrice + freebiesavings;
    }

    if (sellingPrice > shippingThreshold) {
      discountPrice = discountPrice + shippingCharges;
    }

    $('.cart-saving span').text(discountPrice);
  }

  cartSavingsUpdate().then(() => {
    // Move all DOM updates inside here to ensure they happen AFTER savings calculation
    $('.price-details .subtotal').text(`₹${regularTotal}`);
    $('.price-details .discount-price').text(`-₹${discountAmount}`);  
    $('.price-details .cart-shipping-price').html(`${shippingPrice}`);
    $('.price-details .cart-price span.price-amount').text(`₹${totalPrice}`);
    $('.drawer__footer .totals__total-value').text(`₹${totalPrice}`);
    
    // Move the rest of the updatePrices() logic here too:
    const $progressBar = $('.free-shipping--threshold-progress');
    const progressPercent = (Math.max(0, sellingPrice) / shippingThreshold) * 100;
    if ($progressBar.length) {
      $progressBar.css('width', Math.min(progressPercent, 100) + '%');
    }
  });

  //code for free shipping bar start
  const $progressBar = $('.free-shipping--threshold-progress');

  const progressPercent = (Math.max(0, sellingPrice) / shippingThreshold) * 100;
  if ($progressBar.length) {
    $progressBar.css('width', Math.min(progressPercent, 100) + '%');
  }
  //code for free shipping bar end
  if ($('.offer1399-value').val() != undefined) {
    if (parseInt($('.offer1399-value').val()) < 3) {
      $('.offer-by-total .on-3-ofr p span').html(3 - parseInt($('.offer1399-value').val()));
    } else {
      if ($('.buy_at_discount_offer').length==0) {
        $('.offer-by-total li').eq(2).removeClass('active');
        $('.offer-by-total .on-3-ofr p').html('Offer not availed');
      } else {
        $('.offer-by-total .on-3-ofr p').html('Offer availed');
        activeBYOB=1;
      }
    }
    if (parseInt($('.offer1399-value').val()) < 4) {
      $('.offer-by-total .on-4-ofr p span').html(4 - parseInt($('.offer1399-value').val()));
    } else {
      if ($('.buy_at_discount_offer').length == 0 || $('.buy_at_discount_offer').val() == 'buy_3_applied') {
        $('.offer-by-total li').eq(3).removeClass('active');
        $('.offer-by-total .on-4-ofr p').html('Offer not availed');
      } else {
        $('.offer-by-total .on-4-ofr p').html('Offer availed');
        $('.offer-by-total .on-3-ofr p').html('');
        activeBYOB=1;
      }
    }
  } else {
    if (parseInt($('.OFFER_BUY2GET1-value').val()) < 3) {
      $('.offer-by-total .on-3-ofr p span').html(3 - parseInt($('.OFFER_BUY2GET1-value').val()));
    } else {
      $('.offer-by-total .on-3-ofr p').html('Offer availed');
      let cartCuponText = document.querySelector('.cart-coupon-button text');
      if(cartCuponText){
        cartCuponText.innerHTML = `APPLY COUPONS`; 
      }
    }
  }
  updateCoupons(activeBYOB);
  // initializeCartCarousel();
}


function updateCoupons(activeBYOB) {
  // Parse the offer tag count value
  let offer1399Value = parseInt($('.offer1399-value').val());
  let cartTotal=0;
  if ($('.cart-items-total').val() != undefined) {
    cartTotal = parseFloat($('.cart-items-total').val().replace(/,/g, ''));
  }
  // Check if the offer tag count is 3 or more
  if (activeBYOB==1) {
    console.log('in func'+ activeBYOB)
    // Disable the coupon input
    $('input[name="sel-coupon"]').prop('disabled', true);
    $('.cart-coupon-apply').hide();
    $('.coupon-general-messege').html("Coupons are not applicable with the Buy3@1399 and Buy4@1799 offers.");
  } else {
    // Enable the coupon input if the condition is not met
    $('input[name="sel-coupon"]').prop('disabled', false);
    $('.cart-coupon-apply').show();
    $('.coupon-general-messege').html('');

    // Iterate through each coupon radio button
    $('input[name="sel-coupon"]').each(function () {
      // Get the minimum total value for this coupon
      let minTotal = parseFloat($(this).attr('data-min-total'));
      // Get the corresponding "apply" button
      let applyButton = $(this).closest('label').find('.cart-coupon-apply');
  
      // Enable/disable the coupon and show/hide the apply button based on the cart total
      if (cartTotal >= minTotal) {
        $(this).prop('disabled', false);
        applyButton.show();
      } else {
        $(this).prop('disabled', true);
        applyButton.hide();
      }
    });
  }
}
updatePricePostCoupon();
function updatePricePostCoupon() {
  const $shippingPriceElement = $('.cart-shipping-price');
  const shippingThreshold = $shippingPriceElement.data('shipping-threshold');
  const shippingCharges = $shippingPriceElement.data('shipping-charges');
  const totalPrice = $('.price-details .price-amount').text().replace('₹', '').replace(',', '');
  if (totalPrice > shippingThreshold) {
    $('.price-details .cart-shipping-price').html('<s>₹49</s> Free');
  } else {
    $('.price-details .cart-shipping-price').text(`₹${shippingCharges}`);
  }
}

// add freebie with form
// add Freebie tote bag from selection
$(document).on('click', '.freebie-btn button', function (e) {
  $('.cart-freebie .accordion-header button').click();
  // addFreebieToCart(parseInt($('.freebie-checkbox input:checked').val()), true);
  $('.tote-bag-freebie-form .product-variant-id').val(parseInt($('.freebie-checkbox input:checked').val()));
  localStorage.setItem('tote-color', $('.freebie-checkbox input:checked').data('color'));
  $('.tote-bag-freebie-form .product-form__submit').click();
  console.log('tote bag added');
  // $('.cart-freebie').css('display', 'none');
})

// Prevents adding same freebie item again
$(document).ready(function () {
  currentValue = 0;
  initialSelectedValue = 0;
  $(document).on("change", ".freebie-checkbox input", function () {
    currentValue = $(this).val();
    console.log(
        "Check: currentValue " +
        currentValue +
        "initial value" +
        initialSelectedValue
    );

    // Check if the current value is different from the initial selected value
    if (currentValue !== initialSelectedValue) {
      $(".freebie-btn button").removeAttr("disabled").removeClass("disabled");
    } else {
      $(".freebie-btn button")
          .attr("disabled", "disabled")
          .addClass("disabled");
    }
  });

  $(document).on(
      "shown.bs.collapse",
      ".cart-freebie .accordion-collapse",
      function () {
        initialSelectedValue = $('input[name="freebie-checkbox"]:checked').val();
        console.log(
            "currentValue " + currentValue + "initial value" + initialSelectedValue
        );
      }
  );
});

async function cartData() {
  const res = await fetch('/cart.js');
  const response = await res.json();
  return response;
}

// Scrunchie - 45863787495594 - 599
//Argan shampoo and conditioner combo - 45224789246122
// Argon Mask 45 ML - 47603306299562 - 125
// Scalp Massager - 45401136234666 - 799
// Argon Hair Serum 15 ML - 47603288899754 - 599
// Tote Bag - 42894137622698 - 500
async function handleFreeGift() {
  const cart = await cartData();
  let variants;
  const cartPrice = $('.cart-items-total').length > 0 ? parseInt($('.cart-items-total').val().replace(',', '')) : 0;
  if (cartPrice > 0 && cartPrice < 599) {
    variants = {
      '45224789246122': 0,
    };
  } else if (cartPrice >= 599) {
    variants = {
      '45224789246122': 1,
    };
  } else {
    variants = {
      '45224789246122': 0,
    };
  }

  await updateCartItems(variants);
}

async function updateCartItems(variants) {
  try {
      const response = await fetch('/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ updates: variants })
      });
      const data = await response.json();
      console.log(data, 'success data');
      let cart = data;
      if(data.cart_level_discount_applications[0]?.discount_application.title){
      applyDiscount(data.cart_level_discount_applications[0].discount_application.title);}
      document.querySelector('.drawer__heading').innerHTML=`shopping cart <span>( ${cart.item_count} items)</span>`
      document.querySelector('.cart-count-bubble').innerHTML=`<span aria-hidden="true">${cart.item_count}</span>
            <span class="visually-hidden">${cart.item_count} items</span>`
      if(cart.item_count == 0) {
        let cartDrawerInner = document.querySelector('#CartDrawer .drawer__inner');
        cartDrawerInner.innerHTML=`
        <div class="drawer__inner-empty">
        <div class="cart-drawer__warnings center">
          <div class="cart-drawer__empty-content">
              <h2 class="cart__empty-text">Your cart is empty</h2>
              <button class="drawer__close" type="button" onclick="this.closest('cart-drawer').close()" aria-label="Close">
                  <svg xmlns="http://www.w3.org/2000/svg" aria-hidden="true" focusable="false" class="icon icon-close" fill="none" viewBox="0 0 18 17">
                    <path d="M.865 15.978a.5.5 0 00.707.707l7.433-7.431 7.579 7.282a.501.501 0 00.846-.37.5.5 0 00-.153-.351L9.712 8.546l7.417-7.416a.5.5 0 10-.707-.708L8.991 7.853 1.413.573a.5.5 0 10-.693.72l7.563 7.268-7.418 7.417z" fill="currentColor">
                  </path></svg>
              </button>
              <a href="/collections/all" class="button">
                  Continue shopping
              </a>
              <p class="cart__login-title h3">Have an account?</p>
              <p class="cart__login-paragraph">
                  <a href="/account/login" class="link underlined-link">Log in</a> to check out faster.
              </p></div>
            </div>
        </div>`
        document.querySelector('cart-drawer').classList.add('is-empty');
      }
      applyDiscount();
    } catch (error) {
      console.error('Error updating cart:', error);
      }
    await cartDrawerUpdate();
}

async function cartDrawerUpdate() {
  try {
  let cart = await cartData();
  publish(PUB_SUB_EVENTS.cartUpdate, { source: 'freebies', cartData: cart });
  await fetchAndUpdateCart();
  if (typeof updatePrices === 'function') {
    setTimeout(() => {
      updatePrices();
    }, 0);
  }
  let cartCheckoutButton = document.querySelector('.gokwik-checkout');
  // if(cartCheckoutButton) {
  //   cartCheckoutButton.setAttribute('aria-disabled',"false");
  //   cartCheckoutButton.style.pointerEvents = "all";
  // }
  } catch (error) {
    console.error('Error updating cart drawer:', error);
    }
}
async function fetchAndUpdateCart() {
  try {
    let cart = await cartData();
    const quantityInputs = document.querySelectorAll('.quantity.cart-quantity:not(.cart-drawer-quantity)');
    quantityInputs.forEach((input) => {
      const variantId = input.querySelector('.quantity__input').dataset.quantityVariantId; // Get the variant ID from the input element
      const cartItems = cart.items.filter(item => item.variant_id === Number(variantId));
      const totalQuantity = cartItems.reduce((sum, item) => sum + item.quantity, 0);
      input.querySelector('.quantity__input').value = totalQuantity;
    });
    let cartCheckoutButton = document.querySelector('.gokwik-checkout');
    // if(cartCheckoutButton) {
    //   cartCheckoutButton.setAttribute('aria-disabled',"false");
    //   cartCheckoutButton.style.pointerEvents = "all";
    // }
  } catch (error) {
    console.error('Error fetching cart data:', error);
  }
}

if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
  subscribe(PUB_SUB_EVENTS.cartUpdate, () => {
    setTimeout(() => {
      try {
        updatePrices();
      } catch (error) {
        console.error('Error updating prices on cart update:', error);
      }
    }, 0);
  });
}

window.addEventListener('load', fetchAndUpdateCart);
window.addEventListener('load', updatePrices);
